import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Button } from '@pushpay/button';
import { WarningIcon } from '@pushpay/iconography';
import { clsx } from '@pushpay/styles';
import { isCurrentPage } from '../../helpers';
import useStyles from './use-styles';

const AnchorLink = ({
  classes: classesProp,
  isSubItem,
  url,
  children,
  subItemsUrls,
  warning,
  'data-pp-at-target': target,
  ...rest
}) => {
  const classes = useStyles(classesProp);
  const containerClasses = clsx(classes.linkContainer, !isSubItem && classes.topLevelItemLinkContainer, isCurrentPage(url, subItemsUrls) && (isSubItem ? classes.activeSubItem : classes.activeItem));
  const anchorClasses = clsx(classes.basicLink, !isSubItem && classes.topLevelLink);
  return /*#__PURE__*/React.createElement("div", {
    className: containerClasses
  }, /*#__PURE__*/React.createElement("a", Object.assign({
    "data-pp-at-target": target,
    className: anchorClasses,
    href: url
  }, rest), children), warning && /*#__PURE__*/React.createElement("a", {
    "aria-label": warning.warningText,
    title: warning.warningText,
    className: classes.warningLink,
    "data-pp-at-target": `${target}-warningUrl`,
    href: warning.warningUrl
  }, /*#__PURE__*/React.createElement(WarningIcon, {
    "data-pp-at-target": `${target}-warning-icon`,
    className: classes.warningIcon
  })));
};

const ExpandButton = ({
  classes: classesProp,
  children,
  updateExpandStatus,
  expandStatus,
  isActive,
  'data-pp-at-target': target
}) => {
  const classes = useStyles(classesProp);
  const containerClasses = clsx(classes.linkContainer, classes.topLevelItemLinkContainer, isActive && classes.activeItem);
  const buttonClasses = clsx(classes.buttonOverride, classes.basicLink, classes.topLevelLink);
  useEffect(() => {
    if (isActive && expandStatus === 'collapsed') {
      updateExpandStatus();
    }
  }, [isActive]);
  return /*#__PURE__*/React.createElement("div", {
    className: containerClasses
  }, /*#__PURE__*/React.createElement(Button, {
    "data-pp-at-target": target,
    type: "button",
    onClick: updateExpandStatus,
    className: buttonClasses
  }, children));
};

const LinkItem = ({
  isSPA,
  routePath,
  url,
  children,
  classes: classesProp,
  hasSubItems = false,
  isSubItem = false,
  subItemsUrls,
  expandStatus = 'collapsed',
  warning,
  onSelect,
  renderAsExpand,
  ...rest
}) => {
  const classes = useStyles(classesProp);

  if (renderAsExpand || hasSubItems && routePath) {
    return /*#__PURE__*/React.createElement(ExpandButton, Object.assign({
      classes: classes,
      expandStatus: expandStatus,
      updateExpandStatus: onSelect,
      isActive: isCurrentPage(url || routePath, subItemsUrls)
    }, rest), children);
  }

  if (isSPA && routePath) {
    return /*#__PURE__*/React.createElement(NavLink, Object.assign({
      to: routePath,
      className: ({
        isActive
      }) => clsx(classes.basicLink, !isSubItem && classes.topLevelLink, !isSubItem && classes.topLevelItemLinkContainer, // eslint-disable-next-line no-nested-ternary
      isActive ? isSubItem ? classes.activeSubItem : classes.activeItem : undefined),
      onClick: onSelect
    }, rest), children);
  }

  return /*#__PURE__*/React.createElement(AnchorLink, Object.assign({
    classes: classes,
    url: url,
    isSubItem: isSubItem,
    subItemsUrls: subItemsUrls,
    warning: warning,
    onClick: onSelect
  }, rest), children);
};

export default LinkItem;